module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page manage-page mx-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Manage")]), _vm._v(" "), _c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: _vm.isActiveTab(tab.id)
      },
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.currentUser && _vm.isPageReady) ? _c('div', {
    staticClass: "page-content",
    staticStyle: {
      "padding": "unset !important"
    }
  }, [(_vm.active_tab == 'published') ? _c('div', [(!_vm.published_albums || _vm.published_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have not uploaded any albums yet")]), _vm._v(" "), _c('router-link', {
    staticClass: "empty-discover-btn",
    attrs: {
      "to": "/upload/album"
    }
  }, [_vm._v("Upload")])], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.published_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "videoOnlyButtonAction": _vm.openVideoOnlyConfirmDialog,
        "privateButtonAction": _vm.openPrivateConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'privated') ? _c('div', [(!_vm.private_albums || _vm.private_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no private albums")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.private_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "publishButtonAction": _vm.openPublishConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'video_only') ? _c('div', [(!_vm.video_only_albums || _vm.video_only_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no albums only for live video")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.video_only_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "publishButtonAction": _vm.openPublishConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'collaborated') ? _c('div', [(!_vm.collaborated_albums || _vm.collaborated_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no album collaborations")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.collaborated_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [_c('album-card', {
      attrs: {
        "album": album,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog
      }
    })], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'pending') ? _c('div', [(!_vm.pending_albums || _vm.pending_albums.length == 0) ? _c('div', {
    staticClass: "empty-section"
  }, [_c('p', {
    staticClass: "empty-title"
  }, [_vm._v("You have no pending album collaborations")])]) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    staticClass: "covers-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.pending_albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "card-container"
    }, [(album.user.id == _vm.$store.state.auth.user.id) ? _c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "editButtonAction": _vm.editAlbum,
        "deleteButtonAction": _vm.openAlbumDeleteConfirmDialog,
        "releaseButtonAction": _vm.releaseAlbum
      }
    }) : (_vm.notResponded(album)) ? _c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false,
        "acceptButtonAction": _vm.acceptAlbum,
        "denyButtonAction": _vm.denyAlbum
      }
    }) : _c('album-card', {
      attrs: {
        "album": album,
        "showPromoteButton": false
      }
    })], 1)
  }))], 1)], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.show_album_finish_modal) ? _c('div', {
    staticClass: "album-finish-section"
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.closeAlbumFinishModal()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "title-text"
  }, [_vm._v("This album is pending release,\n          "), _c('router-link', {
    staticClass: "link-text",
    attrs: {
      "to": "/upload/album"
    }
  }, [_vm._v("upload another")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "promote-album-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "header-text"
  }, [_vm._v("What Next?")])]), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "promote-album-image"
  }, [_c('div', {
    staticClass: "promote-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "promote-album-description"
  }, [_c('p', [_vm._v("\n              When you added collaborators accept your collaboration via\n              Direct Message or Manage > Pending Collaborations, you will then\n              be able to release the album.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Visit Manage > Pending Collaborations to see who accepted and/or\n              denied your collaboration.\n            ")])])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_album_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_album_delete_confirm_dialog = $$v
      },
      expression: "show_album_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete an Album")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, your followers won't see the album any more. Click\n        OK to delete <" + _vm._s(_vm.album.name) + ">, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeAlbumDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_publish_confirm_dialog),
      callback: function($$v) {
        _vm.show_publish_confirm_dialog = $$v
      },
      expression: "show_publish_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Publish an Album")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the album will be published. Click OK to publish, or\n        click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.publishAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closePublishConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_private_confirm_dialog),
      callback: function($$v) {
        _vm.show_private_confirm_dialog = $$v
      },
      expression: "show_private_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Make album private")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you make this album private it will be removed from public feeds\n        and reposts. Click OK to private, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.privateAlbum()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closePrivateConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_video_only_confirm_dialog),
      callback: function($$v) {
        _vm.show_video_only_confirm_dialog = $$v
      },
      expression: "show_video_only_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Make an album available only for live\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        If you click OK, the album will be available only for live\n        video.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.videoOnlyAlbum()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebe0930","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/manage.vue
// module id = 1610
// module chunks = 180